// extracted by css-extract-rspack-plugin
export default {"buttonBanner":"cm_oS9Cn","disabled":"Vyi4i7ta"};